const counterFilterTypes = {
    INCREASE_COUNTER: "INCREASE_COUNTER",
    DECREASE_COUNTER: "DECREASE_COUNTER",
    RESET_COUNTER: "RESET_COUNTER",
    ALL_SUBCATEGORIES_COUNTER: "ALL_SUBCATEGORIES_COUNTER",
  };
  
  export default counterFilterTypes;